import ClickAwayListener from "react-click-away-listener";
import { useState } from 'react';
import AboutModal from './modals/AboutModal';
import ControlsModal from "./modals/ControlsModal";
import { useLocation, useNavigate } from 'react-router';

function Menu() {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [controlsModalOpen, setControlsModalOpen] = useState<boolean>(false);
    const [aboutModalOpen, setAboutModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

    const onOpenAboutModal = () => {
        setIsOpen(false);
        setAboutModalOpen(true);
    }

    const onOpenControlsModal = () => {
        setIsOpen(false);
        setControlsModalOpen(true);
    }


    return (
        <>
            {aboutModalOpen && <AboutModal onClose={() => setAboutModalOpen(false)}/>}
            {controlsModalOpen && <ControlsModal onClose={() => setControlsModalOpen(false)}/>}
            <ClickAwayListener onClickAway={() => setIsOpen(false)}>
                <div id="menu-component">
                    <div id="menu-open" className={!isOpen ? 'hidden' : '' }>
                        {!isOpen && <div id="menu-header">
                            <svg id="icon" className={isOpen ? 'selected' : ''} onClick={() => setIsOpen(!isOpen)}>
                                <use href="#hamburger"/>
                            </svg>
                            <div id="title">Planets</div>
                        </div>}
                        <div id="menu-content">
                            <div key="icosphere" className={`navigation-link selectable ${location.pathname === '/ico' ? 'active' : ''}`} onClick={() => { navigate('/ico'); setIsOpen(false); }}>
                                <svg>
                                    <use href="#ico"/>
                                </svg>
                                <div>Icosphere</div>
                            </div>
                            <div key="voxel" className={`navigation-link selectable ${location.pathname === '/vox' ? 'active' : ''}`} onClick={() => { navigate('/vox'); setIsOpen(false); }}>
                                <svg>
                                    <use href="#add-voxel"/>
                                </svg>
                                <div>Voxel</div>
                            </div>
                            <div key="controls" className="navigation-link selectable" onClick={() => onOpenControlsModal()}>
                                <svg>
                                    <use href="#controls"/>
                                </svg>
                                <div>Controls</div>
                            </div>
                            <div key="about" className="navigation-link selectable" onClick={() => onOpenAboutModal()}>
                                <svg>
                                    <use href="#question-mark"/>
                                </svg>
                                <div>About</div>
                            </div>
                        </div>
                    </div>
                    <div className={'circle-button' + (isOpen ? ' hidden' : '') } onClick={() => setIsOpen(!isOpen)}>
                        <svg id="icon" className={isOpen ? 'selected' : ''}>
                            <use href="#hamburger"/>
                        </svg>
                    </div>
                </div>
            </ClickAwayListener>
        </>
    );
}

export default Menu;
